import TSfLogin from './index.vue';

TSfLogin.install = app => {
  app.component(TSfLogin.name, TSfLogin);
};

export default TSfLogin;
